import $ from 'jquery';

export default function () {
  $('#skidine').submit(function (e) {
    var values = $('#hotels').val().split('|');
    $('input[name=hotelmail]').val(values[1]);
    $('input[name=hotel]').val(values[0]);
  });
}
